// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wcs-spinner{display:flex;justify-content:center;align-items:center}.wcs-spinner .wcs-spinner__content{width:54px;height:54px}.wcs-spinner.wcs-spinner--small .wcs-spinner__content{width:40px;height:40px}.wcs-spinner.wcs-spinner--tiny .wcs-spinner__content{width:26px;height:26px}.wcs-spinner.wcs-spinner--centered{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}", ""]);
// Exports
module.exports = exports;
